import { NonIdealState, Spinner } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

const PersonCardLoader = ({ className }) => {
  return (
    <NonIdealState
      className={className}
      icon={<Spinner />}
      description="Loading people, please wait."
    />
  );
};

PersonCardLoader.defaultProps = {
  className: undefined,
};

PersonCardLoader.propTypes = {
  className: PropTypes.string,
};

export default PersonCardLoader;
